import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  justify-content: center;
  margin-top: 90px;
`;

export const Background = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  z-index: -1;
  background-color: ${props => props.theme.account.backgroundColor};

  @media screen and (max-width: 700px) {
    background: ${props => props.theme.account.backgroundColorMobile};
  }
`;
